import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "stroke-current transition-all duration-500 ease-in-out dasharray-30 dashoffset-30 group-hover:dashoffset-0 group-focus:dashoffset-0",
  cx: "20",
  cy: "20",
  r: "18.5",
  fill: "#fff"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["rounded-full group focus-primary-out", {'cursor-pointer': !$props.disabled, 'cursor-not-allowed': $props.disabled}]),
    "aria-label": $props.ariaLabel,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    disabled: $props.disabled
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass({'text-black-600 group-hover:text-primary-500 group-focus:text-primary-500 transform': !$props.disabled, 'text-black-200': $props.disabled}),
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("circle", {
        cx: "20",
        cy: "20",
        r: "18.5",
        class: _normalizeClass([$props.disabled ? 'text-black-200' : 'text-black-600', 'stroke-current', 'fill-white'])
      }, null, 2),
      (!$props.disabled)
        ? (_openBlock(), _createElementBlock("circle", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("path", {
        class: _normalizeClass(["stroke-current transform origin-center transition-colors duration-500 ease-in-out", $options.rotationClass]),
        d: "m16 18.354 3.573 3.573a.25.25 0 0 0 .354 0l3.573-3.573",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 2)
    ], 2))
  ], 10, _hoisted_1))
}